import type { PAYMENT_META_RESPONSE } from "@/types/form-types"
import { useQuery } from "@tanstack/react-query"
import { api } from "@/lib/api"

export const useGetPaymentMeta = ({
    universityId,
    batchId,
    applicationId,
}: {
    universityId: string
    batchId: string
    applicationId: string
}) => {
    return useQuery({
        queryFn: async () => {
            const { data } = await api.get<PAYMENT_META_RESPONSE>(
                `/universities/${universityId}/batches/${batchId}/applications/${applicationId}/payment-meta`
            )
            return data
        },
        queryKey: ["payment-meta", applicationId],
        enabled: !!universityId && !!batchId && !!applicationId,
    })
}
